import { useQuery } from '@apollo/client/react';
import { makeStyles } from 'tss-react/mui';
import Divider from '@mui/material/Divider';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import { groupPostCommentsQuery } from '../../apollo/groups';
import type { GroupPost } from '../../types/GroupPost';
import Comment from './comment';

const useStyles = makeStyles()((theme) => ({
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0
  },
  listItem: {
    margin: theme.spacing(0, 0, 1, 0)
  }
}));

type Props = {
  groupPost?: GroupPost;
};

const GroupCommentList = ({ groupPost: groupPostProp }: Props) => {
  const { classes } = useStyles();
  const { data, loading, error } = useQuery(groupPostCommentsQuery, {
    variables: {
      id: groupPostProp.id
    }
  });
  const groupPost = data?.groupPost;

  if (error) { return <ErrorMessage message='Error loading comments.' compact />; }
  if (loading) { return <Loading compact />; }
  if (!groupPost) { return null; }

  if (!groupPost.comments || !groupPost.comments.length) {
    return null;
  }

  return (
    <ul className={classes.list}>
      {groupPost.comments.map((comment, index) => (
        <li key={comment.id} className={classes.listItem}>
          {index > 0 && <Divider sx={{ mb: 2 }} />}
          <Comment comment={comment} groupPost={groupPost} />
        </li>
      ))}
    </ul>
  );
};

export default GroupCommentList;
